<template>
  <div class="card" v-if="leilao">
    <a :href="getUrlLeilao()" style="color: #4a4949; position: relative">
      <!-- TAGS -->
      <div>
        <div style="display: inline-block; position: absolute" v-if="leilao.lotes && leilao.lotes.length > 1">
          <span class="right badge badge-danger" style="background-color: #301904; font-size: 14px">{{ leilao.lotes.length }} LOTES</span>
        </div>
        <div style="display: inline-block; position: absolute" v-else>
          <span class="right badge badge-danger" style="background-color: #301904; font-size: 14px">LOTE ÚNICO</span>
        </div>

        <!-- TAGS DE LOTE ATUAL-->
        <!--
        <div style="position: absolute; float: right; top: 293px; left: 1px" v-if="leilao.lotes && leilao.lotes.length > 1">
          <span class="right badge badge-success" style="background-color: #301904; font-size: 14px">
            Lote {{ indice_lote + 1 }}/{{ leilao.lotes.length }}
          </span>
        </div>

                <div style="position: absolute; float: right; top: 293px; left: 1px" v-else>
          <span class="right badge badge-success" style="background-color: #301904; font-size: 14px">Lote único</span>
        </div>
        

        <div style="position: absolute; float: right; top: 302px; left: 32px" v-if="leilao.lotes && leilao.lotes.length > 1">
          <span style="font-size: 15px; font-weight: bold;">LOTE  {{ lote_selecionado.lote_numero }}</span>
        </div>
        -->

        <img v-if="imagem_lote" :src="getImagePath()" style="width: 100%; height: 220px" class="im-logo" />

        <!-- CENTRALIZAR ESSA -->
        <div style="width: 100%; height: 220px; display: flex; justify-content: center; align-items: center" v-else>
          <img :src="getImagePath()" style="width: 100%; max-width: 250px" class="im-logo" />
        </div>

        <!--
        <div style="position: absolute; float: right; top: 185px; right: 12px">
          <span class="right badge badge-danger" style="background-color: #4a4949; font-size: 14px">
            <i class="fa-regular fa-eye" style="margin-right: 5px"></i>
            {{ lote_selecionado.lote_visits }}
          </span>
        </div>
        -->

        <div style="display: inline-block; position: absolute; top: 0px; left: 1px" v-if="leilao.lotes && leilao.lotes.length > 1">
          <span class="right badge badge-danger" style="background-color: #301904; font-size: 14px">{{ leilao.lotes.length }} LOTES</span>
        </div>

        <div style="position: absolute; float: left; top: 185px; left: 1px" v-if="lote_selecionado.categoria">
          <span class="right badge badge-danger" style="background-color: #301904; font-size: 14px; text-transform: uppercase">
            {{ lote_selecionado.categoria.nome }}
          </span>
        </div>

        <div style="position: absolute; float: right; top: 0px; right: 5px" v-if="lote_selecionado.lote_situacao == 'desocupado'">
          <span class="right badge badge-success" style="background-color: #301904 !important; font-size: 14px">DESOCUPADO</span>

          <!-- TAGS DE STATUS QUANDO JÁ TEM A TAG DESOCUPADO-->
          <div style="position: absolute; float: right; top: 0px; right: 114px">
            <span
              class="right badge badge-success"
              style="font-size: 14px; background-color: red !important"
              v-if="lote_selecionado.lote_status == 'retirado'"
            >
              LOTE RETIRADO
            </span>

            <span class="right badge badge-success" style="font-size: 14px; margin-right: 5px" v-if="lote_selecionado.lote_status == 'vendido'">
              LOTE VENDIDO
            </span>

            <span
              class="right badge badge-success"
              style="margin-right: 5px; font-size: 14px; background-color: #301904 !important; "
              v-if="lote_selecionado.lote_status == 'sem_licitante'"
            >
              LOTE SEM LICITANTE
            </span>
          </div>
        </div>

        <!-- TAGS DE STATUS QUANDO NÃO TEM A TAG DESOCUPADO-->
        <div style="position: absolute; float: right; top: 0px; right: 5px" v-else>
          <span
            class="right badge badge-success"
            style="font-size: 14px; background-color: red !important"
            v-if="lote_selecionado.lote_status == 'retirado'"
          >
            LOTE RETIRADO
          </span>

          <span class="right badge badge-success" style="font-size: 14px; text-transform: uppercase" v-if="lote_selecionado.lote_status == 'vendido'">
            Lote vendido
          </span>

          <span
            class="right badge badge-success"
            style="font-size: 14px; background-color: #301904 !important;"
            v-if="lote_selecionado.lote_status == 'sem_licitante'"
          >
            LOTE SEM LICITANTE
          </span>
        </div>

        <!-- TAGS LANCE -->
        <div v-if="!pracas_fechadas">
          <div
            style="position: absolute; float: left; top: 165px; left: 0px"
            v-if="lote_selecionado.lote_lance > 0 && leilao.leilao_1_modalidade != 'venda'"
          >
            <span class="left badge badge-danger" style="background-color: #4a4949; font-size: 18px">
              Maior lance: R$ {{ toCurrency(lote_selecionado.lote_lance) }}
            </span>
            <div v-if="lote_selecionado.user">
              <span class="right badge badge-danger" style="background-color: #4a4949; font-size: 18px">
                {{ getApelidoFormatado(lote_selecionado.user.apelido) }}
              </span>
            </div>
          </div>
          <div v-else-if="leilao.leilao_1_modalidade != 'venda'" style="position: absolute; float: left; top: 192px; left: 0px">
            <span class="left badge badge-danger" style="background-color: #4a4949; font-size: 18px">
              Lance inicial: R$ {{ toCurrency(getValorAtual(lote_selecionado)) }}
            </span>
          </div>
        </div>
      </div>

      <div style="border-bottom: 1px solid gray"></div>

      <div class="card-body" style="padding: 0px 0px 0px 0px; text-align: center; font-family: 'Montserrat', sans-serif; text-transform: uppercase">
        <!--<div style="border-bottom: 1px solid gray; line-height: 2px !important; margin-top: 5px">
          <h5 style="font-weight: bold">
            {{ leilao.cidade }} - {{ leilao.estado }}
            <br />
            <a style="font-size: 12px; color: #adadad">Leilão #{{ leilao.id }}</a>
          </h5>
        </div>
        -->

        <div style="border-bottom: 2px solid gray; text-align: left; line-height: 15px" class="p-2">
          <img width="75px" height="45px" :src="getLeilaoPath()" style="top: 225px; left: 5px; position: absolute" />
          <div style="margin-top: 2px; margin-left: 75px">
            <div style="text-align: left !important">
              <span style="font-size: 16px; font-weight: bold; word-wrap: break-word">{{ leilao.cidade }} - {{ leilao.estado }}</span>
              <br />
            </div>
            <div style="margin-top: 7px !important">
              <a style="font-size: 12px">Leilão ID {{ leilao.id }}</a>
            </div>
            <!--
            <span
            class="right badge badge-danger"
            style="text-transform: uppercase; font-size: 12px; margin-left: 10px"
            v-if="leilao && leilao.leilao_retirado == 1"
          >
            Leilão retirado
          </span>
          -->

            <!--
          <div style="position: absolute; float: right; top: 252px; right: 85px;">
            <span
              class="right badge badge-danger"
               style="text-transform: uppercase; font-size: 12px; margin-left: 10px"
              v-if="lote_selecionado.lote_status == 'retirado'"
            >
            Leilão retirado
            </span>
            </div>
            -->
          </div>
        </div>

        <!-- LOTE CONTAGEM -->
        <div style="border-bottom: 2px solid gray; text-align: left; line-height: 1px; text-align: center">
          <div style="margin-top: 18px; margin-bottom: 7px !important">
            <!--
            <span
              v-if="leilao.lotes && leilao.lotes.length > 1"
              class="right badge badge-success"
              style="text-transform: none; margin-bottom: 7px; background-color: #301904; font-size: 12px"
            >
              Lote {{ indice_lote + 1 }}/{{ leilao.lotes.length }}
            </span>

            <span
              v-else
              class="right badge badge-success"
              style="text-transform: none; margin-bottom: 7px; background-color: #301904; font-size: 12px"
            >
              Lote único
            </span>
            -->

            <p style="font-size: 15px; color: #4a4949; font-weight: 400">LOTE {{ lote_selecionado.lote_numero }}</p>
            <p
              style="
                padding-left: 26px;
                padding-right: 26px;
                font-size: 15px;
                color: #4a4949;
                font-weight: bold;
                margin-top: 4px;
                line-height: 16px;
                margin-top: -7px;
                margin-bottom: 0px;
              "
            >
              <span v-html="getFormatedTitle(lote_selecionado.lote_titulo)"></span>
            </p>
          </div>
        </div>

        <div style="line-height: 15px; margin-top: 5px; text-align: left" class="p-2">
          <b style="font-size: 14px">
            Modalidade:
            <a v-if="leilao.leilao_1_modalidade == 'venda'" style="color: #4a4949; font-weight: 400">VENDA DIRETA</a>
            <a v-else style="color: #4a4949; font-weight: 400">{{ leilao.leilao_1_modalidade }}</a>
          </b>
          <br />
          <b style="font-size: 14px">
            Local:
            <a style="color: #4a4949; font-weight: 400; text-transform: none">{{ leilao.leilao_local }}</a>
          </b>
        </div>
        <!-- DATAS E VALORES DOS LEILÕES -->
        <div
          v-if="leilao.leilao_num_pracas > 1 && !venda_direta"
          style="border-bottom: 1px solid gray; text-align: left; line-height: 15px"
          class="p-2"
        >
          <div
            style="font-size: 14px; color: #545353"
            :class="leilao.leilao_1_realizado === 1 || lote_selecionado.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
          >
            <b>1º Leilão:</b>
            {{ formatDate(leilao.leilao_1_data) + "h" }} por R$ {{ toCurrency(lote_selecionado.lote_valor_1) }}
          </div>

          <!-- DATA 2 -->
          <div
            :class="leilao.leilao_2_realizado === 1 || lote_selecionado.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
            style="font-size: 14px; color: #545353"
            v-if="leilao.leilao_num_pracas >= 2"
          >
            <b>2º Leilão:</b>
            {{ formatDate(leilao.leilao_2_data) + "h" }} por R$ {{ toCurrency(lote_selecionado.lote_valor_2) }}
          </div>

          <div style="font-size: 14px; color: #545353" v-else><br /></div>

          <!-- DATA 3 -->
          <div
            :class="leilao.leilao_3_realizado === 1 || lote_selecionado.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
            style="font-size: 14px; color: #545353"
            v-if="leilao.leilao_num_pracas >= 3"
          >
            <b>3º Leilão:</b>
            {{ formatDate(leilao.leilao_3_data) + "h" }} por R$ {{ toCurrency(lote_selecionado.lote_valor_3) }}
          </div>

          <div style="font-size: 14px; color: #545353" v-else><br /></div>

          <!-- DATA 4 -->
          <div
            :class="leilao.leilao_4_realizado === 1 || lote_selecionado.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
            style="font-size: 14px; color: #545353"
            v-if="leilao.leilao_num_pracas >= 4"
          >
            <b>4º Leilão:</b>
            {{ formatDate(leilao.leilao_4_data) + "h" }} por R$ {{ toCurrency(lote_selecionado.lote_valor_4) }}
          </div>

          <div style="font-size: 14px; color: #545353" v-else><br /></div>
        </div>

        <!-- ÚNICO LEILÃO-->
        <div
          v-else-if="leilao.leilao_num_pracas == 1 && !venda_direta"
          style="border-bottom: 1px solid gray; text-align: left; line-height: 15px; text-transform: none"
          class="p-2"
        >
          <div
            style="text-transform: uppercase; margin-bottom: 0px; font-size: 12px; color: #545353"
            :class="leilao.leilao_1_realizado === 1 || lote_selecionado.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
          >
            <b style="">Único leilão:</b>
            {{ formatDate(leilao.leilao_1_data) + "h" }}
            <a>por</a>
            R$ {{ toCurrency(lote_selecionado.lote_valor_1) }}
          </div>
          <div style="font-size: 14px; color: #545353"><br /></div>
          <div style="font-size: 14px; color: #545353"><br /></div>
          <div style="font-size: 14px; color: #545353"><br /></div>
        </div>

        <!-- VENDA DIRETA-->
        <div v-else-if="venda_direta" style="border-bottom: 1px solid gray; text-align: left; line-height: 15px; text-transform: none" class="p-2">
          <div
            style="text-transform: uppercase; margin-bottom: 0px; font-size: 12px; color: #545353"
            :class="leilao.leilao_1_realizado === 1 || lote_selecionado.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
          >
            <b style="">Disponível até:</b>
            {{ formatDate(leilao.leilao_1_data) + "h" }}
            <a>por</a>
            R$ {{ toCurrency(lote_selecionado.lote_valor_1) }}
          </div>
          <div style="font-size: 14px; color: #545353"><br /></div>
          <div style="font-size: 14px; color: #545353"><br /></div>
          <div style="font-size: 14px; color: #545353"><br /></div>
        </div>
      </div>
    </a>
    <i
      class="fa-solid fa-angles-right ic"
      style="cursor: pointer; font-size: 25px; float: right; position: absolute; top: 300px; right: 0px; padding-right: 3px"
      @click="proximoLote(indice_lote + 1)"
      v-if="leilao.lotes.length > 1"
    ></i>

    <i
      class="fa-solid fa-angles-left ic"
      style="cursor: pointer; font-size: 25px; float: left; position: absolute; top: 300px; left: 0px; padding-left: 3px"
      @click="proximoLote(indice_lote - 1)"
      v-if="leilao.lotes.length > 1"
    ></i>
    <!--
    <div class="card-footer" style="padding: 0px 0px 0px 0px">
      <div class="input-group mb-3">
        <!--
        <div class="input-group-prepend" v-if="leilao.lotes.length > 1">
          <button
            type="button"
            class="btn btn-info arrow-pass"
            :class="venda_direta ? 'btn-yellow' : ''"
            id="confirmar"
            @click="proximoLote(indice_lote - 1)"
            :disabled="indice_lote + -1 < 0"
          >
            <i class="fa-solid fa-angles-left s"></i>
          </button>
        </div>
        -->
    <!--
        <input
          type="text"
          class="form-control"
          :class="venda_direta ? 'back-yellow' : 'back-brown'"
          autofocus
          :value="texto_btn"
          readonly="true"
          style="font-weight: bold; text-align: center; border: none; font-size: 18px"
        />
        -->
    <!--
        <span class="input-group-append" v-if="leilao.lotes.length > 1">
          <button
            :class="venda_direta ? 'btn-yellow' : ''"
            type="button"
            class="btn btn-info arrow-pass"
            id="confirmar"
            @click="proximoLote(indice_lote + 1)"
            :disabled="indice_lote + 1 >= leilao.lotes.length"
          >
            <i class="fa-solid fa-angles-right"></i>
          </button>
        </span>
      </div>
    </div>
    -->
  </div>
</template>

<script>
import auxFormatacao from "../../controller/auxFormatacao";
import wppController from "../../controller/wppController";
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import moment from "moment";
import currencyController from "../../controller/currencyController";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  mixins: [wppController, sweetAlert, Swal, currencyController, auxFormatacao],

  props: ["leilao", "index"],

  data() {
    return {
      container: {},
      nome: "",
      email: "",
      senha: "",
      tipo_usuario: "",
      isLoading: false,
      lote_selecionado: "",
      indice_lote: "",
      imagem_lote: "",
      venda_direta: "",
      texto_btn: "",
      fade: false,
      pracas_fechadas: false,
    };
  },

  mounted() {
    if (this.leilao.lotes.length) {
      this.lote_selecionado = this.leilao.lotes[0];
      this.indice_lote = 0;

      this.buscarImagemLote();
      this.buscarUltimaPraca();

      console.log("Primeiro lote do leilão " + this.leilao.leilao_titulo + " = " + this.lote_selecionado.id);
      console.log(this.lote_selecionado);
    }

    if (this.leilao.leilao_1_modalidade == "venda") {
      this.venda_direta = true;
    }

    console.log("Todos os lotes do leilão " + this.leilao.leilao_titulo);
    console.log(this.leilao.lotes);
  },

  methods: {
    getValorAtual(lote) {
      //PRAÇA ATUAL
      if (this.leilao.leilao_num_pracas >= 1 && this.leilao.leilao_1_realizado == 0) {
        return lote.lote_valor_1;
      } else if (this.leilao.leilao_num_pracas >= 2 && this.leilao.leilao_2_realizado == 0) {
        return lote.lote_valor_2;
      } else if (this.leilao.leilao_num_pracas >= 3 && this.leilao.leilao_3_realizado == 0) {
        return lote.lote_valor_3;
      } else if (this.leilao.leilao_num_pracas >= 4 && this.leilao.leilao_4_realizado == 0) {
        return lote.lote_valor_4;
      } else {
        this.pracas_fechadas = true;
        return null;
      }
    },

    getUrlLeilao() {
      if (this.leilao.lotes && this.leilao.lotes.length > 1) {
        return "/leilao/" + this.leilao.id + "/lotes";
      } else {
        return "/lote/" + this.leilao.lotes[0].id;
      }
    },

    getFormatedTitle(title) {
      if (title && title.length > 72) {
        return title.substring(0, 72) + "...";
      } else if (title && title.length <= 32) {
        return title;
      } else {
        return title;
      }
    },

    proximoLote(indice) {
      console.log("Indice " + indice);
      console.log("Length " + this.leilao.lotes.length);

      if (indice < this.leilao.lotes.length && indice >= 0) {
        this.lote_selecionado = this.leilao.lotes[indice];
        this.indice_lote = indice;

        this.buscarImagemLote();
        this.buscarUltimaPraca();
      } else {
        this.showErrorMessageWithButton("Ops...", "Este é o último lote");
      }

      console.log(this.lote_selecionado);
      console.log(this.lote_selecionado.user);
      console.log(this.lote_selecionado.user.apelido);
    },

    buscarUltimaPraca() {
      if (this.lote_selecionado) {
        if (this.leilao.leilao_num_pracas >= 1 && this.leilao.leilao_1_realizado == 0) {
          this.venda_direta = this.leilao.leilao_2_modalidade == "venda";
          this.gerarTexto(this.leilao.leilao_1_data, this.leilao.leilao_1_modalidade);
        } else if (this.leilao.leilao_num_pracas >= 2 && this.leilao.leilao_2_realizado == 0) {
          this.venda_direta = this.leilao.leilao_2_modalidade == "venda";
          this.gerarTexto(this.leilao.leilao_2_data, this.leilao.leilao_2_modalidade);
        } else if (this.leilao.leilao_num_pracas >= 3 && this.leilao.leilao_3_realizado == 0) {
          this.venda_direta = this.leilao.leilao_3_modalidade == "venda";
          this.gerarTexto(this.leilao.leilao_3_data, this.leilao.leilao_3_modalidade);
        } else if (this.leilao.leilao_num_pracas >= 4 && this.leilao.leilao_4_realizado == 0) {
          this.venda_direta = this.leilao.leilao_4_modalidade == "venda";
          this.gerarTexto(this.leilao.leilao_4_data, this.leilao.leilao_4_modalidade);
        } else {
          //CASO NENHUMA PRAÇA TENHA SIDO REALIZADA AINDA
          this.gerarTexto(this.leilao.leilao_1_data, this.leilao.leilao_1_modalidade);
        }
      }

      console.log("Venda direta lote " + this.lote_selecionado.id + " ? " + this.venda_direta);
    },

    gerarTexto(data_proxima_praca, modalidade) {
      if (modalidade != "venda") {
        let data = this.formatDateNew(data_proxima_praca);

        if (data != "Invalid date") {
          let vencido = new Date() >= new Date(data_proxima_praca);

          if (vencido) {
            this.texto_btn = "Aberto para lances";
          } else {
            this.texto_btn = "Em breve";
          }
        }
      } else {
        this.texto_btn = "Venda direta";
      }
    },

    formatDateNew(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },

    buscarImagemLote() {
      this.imagem_lote = this.lote_selecionado.thumb;
    },

    getLeilaoPath() {
      if (this.leilao.path) {
        if (this.leilao.path && this.leilao.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + this.leilao.path + "/" + this.leilao.arquivo;
        } else if (
          (this.leilao.path && this.leilao.path.includes("rochaleiloes")) ||
          (this.leilao.arquivo && this.leilao.arquivo.includes("fotos_"))
        ) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + this.leilao.path + "/" + this.leilao.arquivo;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + this.leilao.path + "/" + this.leilao.arquivo;
        }
      } else {
        return "/images/logo.png";
      }
    },

    getImagePath() {
      if (this.imagem_lote) {
        if (this.imagem_lote.path && this.imagem_lote.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + this.imagem_lote.path + "/" + this.imagem_lote.thumb;
        } else if ((this.imagem_lote.path && this.imagem_lote.path.includes("rochaleiloes")) || this.imagem_lote.img.includes("fotos_")) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + this.imagem_lote.path + "/" + this.imagem_lote.img;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + this.imagem_lote.path + "/" + this.imagem_lote.img;
        }
      } else {
        return "/images/logo.png";
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else if (!this.validateEmail()) {
        this.showErrorMessageWithButton("Ops...", "Digite um email válido!");
      } else if (this.senha == "") {
        this.showErrorMessageWithButton("Ops...", "A senha não pode ficar em branco!");
      } else {
        this.create();
      }
    },

    create() {
      this.isLoading = true;

      let data = {
        nome: this.nome,
        email: this.email,
        senha: this.senha,
        chave: this.generateKey(),
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/users/create`, data)
        .then((response) => {
          console.log("Usuário criado!");
          console.log(response);

          this.showSuccessMessage("Usuário criado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return true;
      } else {
        return false;
      }
    },

    generateKey() {
      return Math.random().toString(36).slice(2);
    },
  },
};
</script>

<style scoped>
.ic:hover {
  transition-duration: 500ms;
  transform: scale(1.2);
  color: #696969;
}

h5 {
  font-size: 18px;
  color: #4a4949;
}

.swal-modal {
  color: green;
  background-color: rgba(63, 255, 106, 0.69);
  border: 3px solid white;
}

.swal-overlay {
  background-color: rgba(43, 165, 137, 0.45);
}

.im-logo {
  -o-object-fit: cover;
  object-fit: cover;
}

.arrow-pass:hover {
  opacity: 0.7;
}

.realizado {
  text-decoration: line-through;
}

.btn-yellow {
  background-color: #f7de5e;
  border-color: #f7de5e;
  color: white;
}

.back-yellow {
  background-color: #f7de5e;
  border-color: #f7de5e;
  color: #301904;
}

.back-brown {
  background-color: #301904;
  color: white;
}
</style>
